import useToggle from '@lyearn/core/hooks/useToggle';
import { Trans, useTranslation } from '@lyearn/i18n';
import { HeaderBanner, HeaderBannerTypes } from '@lyearn/molecules';
import { AvatarGroupHorizontal, Typography } from '@lyearn/ui';
import ContentConsumptionModal from '@/modules/journey/views/JourneyDetails/components/JourneyStep/components/ContentConsumptionModal';
import { JourneyStepSessionAttendeeAdditionType, ResourceTypeEnum } from '@/types/schema';

import { useGetJourneyStepTraineeSessionQuery } from '../../../corporate/modules/course/views/CourseDetails/graphql/queries/generated/getJourneyStepTraineeSession';
import { JourneyContentHeaderProps } from './types';
import { geti18nKey } from './utils';

const JourneyContentHeader = (props: JourneyContentHeaderProps) => {
  const { t } = useTranslation(['Journey']);
  const [showConsumptionDialog, { toggle: toggleConsumptionDialog }] = useToggle();

  const { contentType = ResourceTypeEnum.Course, sessionId, content } = props;

  const [stepTraineeSessionData, _] = useGetJourneyStepTraineeSessionQuery({
    variables: {
      input: {
        sessionId,
      },
    },
  });

  const batchId = stepTraineeSessionData?.data?.getJourneyStepTraineeSession?.batchId;
  const journeyStepId = stepTraineeSessionData?.data?.getJourneyStepTraineeSession?.journeyStepId;
  const isSelectAll =
    stepTraineeSessionData?.data?.getJourneyStepTraineeSession?.attendeeAdditionType ===
    JourneyStepSessionAttendeeAdditionType.All;
  const participantIds = stepTraineeSessionData?.data?.getJourneyStepTraineeSession?.attendeeIds;
  const excludeParticipantIds =
    stepTraineeSessionData?.data?.getJourneyStepTraineeSession?.excludeAttendeeIds;
  const attendeeIds = stepTraineeSessionData?.data?.getJourneyStepTraineeSession?.attendeeIds;
  const users =
    stepTraineeSessionData?.data?.getJourneyStepTraineeSession?.participantsProfiles?.map(
      (profile) => {
        return {
          name: profile.name,
          src: profile.profilePicture,
        };
      },
    ) ?? [];

  if (!users?.length) {
    return null;
  }

  const usersCount = attendeeIds?.length ?? 1;

  const i18nKey = geti18nKey(usersCount);
  const AvatarsComponent = (
    <AvatarGroupHorizontal avatars={users} className="me-8" size="xx-small" />
  );

  return (
    <>
      <HeaderBanner
        Avatars={AvatarsComponent}
        action={{
          title: t('Common:Actions.Edit'),
          onAction: toggleConsumptionDialog,
        }}
        appearance={'purple' as HeaderBannerTypes}
        title={
          <Trans
            components={{
              label: <Typography variant="label-02" />,
            }}
            i18nKey={i18nKey}
            values={{
              count: usersCount - 2,
              contentType: contentType.toLowerCase(),
              user1: users?.[0]?.name,
              user2: users?.[1]?.name,
            }}
          />
        }
      />
      {showConsumptionDialog ? (
        <ContentConsumptionModal
          batchId={batchId ?? ''}
          content={content}
          excludeParticipantIds={excludeParticipantIds}
          isEditMode={true}
          isSelectAll={false}
          journeyStepId={journeyStepId ?? ''}
          participantIds={participantIds}
          sessionId={sessionId}
          onClose={toggleConsumptionDialog}
        />
      ) : null}
    </>
  );
};

export default JourneyContentHeader;
